import useStatefulRef from "@bedrock-layout/use-stateful-ref";
import React, { useRef } from "react";
function useForwardedRef(forwardedRef, config = { isStateful: true }) {
  const statefulRef = useStatefulRef(null);
  const ref = useRef(null);
  const innerRef = config.isStateful ? statefulRef : ref;
  React.useEffect(() => {
    if (!forwardedRef)
      return;
    if (typeof forwardedRef === "function") {
      forwardedRef(innerRef.current);
    } else {
      forwardedRef.current = innerRef.current;
    }
  });
  return innerRef;
}
export { useForwardedRef as default };
